import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Directory from "@/pages/Directory";
import Contact from "@/pages/Contact";
import MembersArea from "@/pages/MembersArea";
import Events from "@/pages/Events";
import NotFound from "@/pages/NotFound";
import AvisoLegal from "@/pages/legal/AvisoLegal";
import PoliticaPrivacidad from "@/pages/legal/PoliticaPrivacidad";
import PoliticaCookies from "@/pages/legal/PoliticaCookies";
import DirectoryDetail from "@/pages/DirectoryDetail";
import Institutional from "@/pages/Institutional";
import JornadaNetworking from "@/pages/JornadaNetworking";
import PressReleaseDetail from "@/pages/PressReleaseDetail";

import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminOverview from "@/components/admin/AdminOverview";
import NewsManager from "@/components/admin/NewsManager";
import BoardManager from "@/components/admin/BoardManager";
import DirectoryManager from "@/components/admin/DirectoryManager";
import EventsManager from "@/components/admin/EventsManager";
import TarifaNewsManager from "@/components/admin/TarifaNewsManager";
import WeeklyPlansManager from "@/components/admin/WeeklyPlansManager";
import MessagesManager from "@/components/admin/MessagesManager";

function App() {
    return (
        <HelmetProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public site */}
                        <Route element={<PublicLayout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/institucional" element={<Institutional />} />
                            <Route path="/institucional/actualidad/:slug" element={<PressReleaseDetail />} />
                            <Route path="/noticias" element={<News />} />
                            <Route path="/noticias/:slug" element={<NewsDetail />} />
                            <Route path="/eventos" element={<Events />} />
                            <Route path="/eventos/jornada-networking" element={<JornadaNetworking />} />
                            <Route path="/directorio" element={<Directory />} />
                            <Route path="/directorio/:slug" element={<DirectoryDetail />} />
                            <Route path="/area-socios" element={<MembersArea />} />
                            <Route path="/contacto" element={<Contact />} />
                            <Route path="/aviso-legal" element={<AvisoLegal />} />
                            <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
                            <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
                            <Route path="*" element={<NotFound />} />
                        </Route>

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<AdminOverview />} />
                            <Route path="news" element={<NewsManager />} />
                            <Route path="board" element={<BoardManager />} />
                            <Route path="directory" element={<DirectoryManager />} />
                            <Route path="events" element={<EventsManager />} />
                            <Route path="tarifa-news" element={<TarifaNewsManager />} />
                            <Route path="weekly-plans" element={<WeeklyPlansManager />} />
                            <Route path="messages" element={<MessagesManager />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster />
            </AuthProvider>
        </HelmetProvider>
    );
}

export default App;
